import { Q, Query, Relation } from "@nozbe/watermelondb";
import { Associations } from "@nozbe/watermelondb/Model";
import {
  children,
  field,
  relation,
  text,
} from "@nozbe/watermelondb/decorators";
import {
  StockCountSource,
  StockCountStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { BaseModel } from "./Base";
import StockCountLine from "./StockCountLine";
import Location from "./Location";

export default class StockCount extends BaseModel {
  static table = "stock_counts";

  static associations: Associations = {
    stock_count_lines: {
      type: "has_many",
      foreignKey: "stock_count_id",
    },
  };

  @relation("locations", "location_id") location: Relation<Location>;

  @text("name") name: string;

  @text("retailer_stocktake_id") retailerStocktakeId: string | null;
  @text("status") status: StockCountStatus;
  @text("source") source: StockCountSource;

  @children("stock_count_lines")
  items: Query<StockCountLine>;

  // If you require millisecond precision for your date fields in WatermelonDB,
  // you would need to implement a custom serialization and deserialization process.
  // this is sufficient for our use case
  @field("items_last_fetch_millis")
  itemsLastFetchMillis!: number;

  // Method to get a child item by its ID
  async getChildItemById(itemId: string): Promise<StockCountLine | null> {
    try {
      const item = await this.collections
        .get<StockCountLine>(StockCountLine.table)
        .find(itemId);
      return item;
    } catch (error) {
      console.error("Error retrieving child item:", error);
      return null;
    }
  }
}
